/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  _initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  return {
    // canAdmin: currentUser && currentUser.access === 'admin',
    canAdmin: true,
  };
}
